import React from "react";
import Hero from "./Hero";
import ServicesPage from "../services/ServicesPage";
import AboutPage from "../about/AboutPage";
import ContactsPage from "../contacts/ContactsPage";
import Testimonials from "./Testimonials";
import { Helmet } from "react-helmet-async";
import FloatingContactButtons from "../../components/FloatingContactButtons"; // ✅ NEW IMPORT


const HomePage = () => {
  return (
    <>
      <Helmet>
        <title>SPK Academy & Publishing, Online Classes, Books & Tutoring</title>
        <meta
          name="description"
          content="SPK Academy & Publishing offers expert-led online classes, assessment books, and personalized tutoring in Mathematics and Physical Sciences. Empowering students to succeed."
        />
        <meta property="og:title" content="SPK Academy & Publishing – Education & Publishing Services" />
        <meta
          property="og:description"
          content="Quality education, publishing, printing, and graphic design services. Join SPK Academy today."
        />
        <meta property="og:url" content="https://spkrobertacademy.com/" />
        <meta name="robots" content="index, follow" />
      </Helmet>
      <div
        className="w-full bg-cover bg-no-repeat bg-top bg-fixed bg-black sm:bg-fixed"
        style={{
          backgroundImage: "url(/media/img/Hero.jpeg)",
        }}
      >
        <div className="container mx-auto px-2 py-6">
          <Hero />
        </div>

        <div className="relative overflow-hidden bg-orange-400">
          {/* Animated Background */}
          <div className="absolute inset-0 pointer-events-none">
            <svg
              className="absolute bottom-0 left-0 w-[200%] h-full animate-wave"
              viewBox="0 0 1440 320"
              preserveAspectRatio="none"
            >
              <path
                fill="rgba(59,130,246,0.08)"
                d="M0,160L48,170.7C96,181,192,203,288,197.3C384,192,480,160,576,154.7C672,149,768,171,864,186.7C960,203,1056,213,1152,197.3C1248,181,1344,139,1392,117.3L1440,96V320H0Z"
              />
            </svg>

            <svg
              className="absolute bottom-0 left-0 w-[200%] h-full animate-wave-slow"
              viewBox="0 0 1440 320"
              preserveAspectRatio="none"
            >
              <path
                fill="rgba(6,182,212,0.06)"
                d="M0,224L60,202.7C120,181,240,139,360,149.3C480,160,600,224,720,229.3C840,235,960,181,1080,170.7C1200,160,1320,192,1380,208L1440,224V320H0Z"
              />
            </svg>
          </div>

          {/* Content */}
          <div className="relative z-10">
            <ServicesPage />
          </div>
        </div>

        <div className="container mx-auto px-2 py-6">
          <AboutPage />
          <Testimonials />
          <ContactsPage />
        </div>
        <FloatingContactButtons />
      </div>
    </>
  );
};

export default HomePage;

